export enum CityDataTestidEnum {
  CITY_ASSISTED_PURCHASE_BUTTON = 'city--assisted-purchase-button',
  CITY_BRANCH_SCHEDULE_BUTTON = 'city--branch-schedule-button',
  CITY_MEDPREV_ONLINE_SCHEDULE_BUTTON = 'city--medprev-online-schedule-button',
  CITY_NOTIFY_ME_BUTTON = 'city--notify-me-button',
  CITY_TELEMEDICINE_SCHEDULE_BUTTON = 'city--telemedicine-schedule-button',
  CITY_SEARCH_SECTION_DEFAULT = 'city--search-section-default',
  CITY_SEARCH_SECTION_CITY = 'city--search-section-city',
  CITY_SEARCH_SECTION_BRANCH = 'city--search-section-branch',
  CITY_SEARCH_SECTION_BRANCH_TITLE = 'city--search-section-branch-title',
  CITY_SEARCH_SECTION_TITLE = 'city--search-section-title',
  CITY_SEARCH_SECTION_SUBTITLE = 'city--search-section-subtitle',
  CITY_CTA_BOX_BUTTONS = 'city--cta-box-buttons',
  CITY_LOCATION_BAR = 'city--location-bar',
  CITY_MOST_SEARCHED_SECTION = 'city--most-searched-section',
  CITY_MOST_SEARCHED_SECTION_BRANCH = 'city--most-searched-section-branch',
  CITY_MOST_SEARCHED_SECTION_CARD = 'city--most-searched-section-card',
  CITY_MOST_SEARCHED_SECTION_FILTER = 'city--most-searched-section-filter',
  CITY_FILTER_IMAGE_EXAM = 'city---filter-image-exam',
  CITY_FILTER_ONLINE_CONSULTATION = 'city--home-filter-online-consultation',
  CITY_FILTER_PRESENTIAL_CONSULTATION = 'city--home-filter-presential-consultation',
  CITY_FILTER_LABORATORIAL_EXAM = 'city--filter-laboratorial-exam',
  CITY_BANNER_SECTION = 'city--banner-section',
  CITY_BANNER_SECTION_CAROUSEL = 'city--banner-section-carousel',
  CITY_BANNER_SHEET_OPEN = 'city--banner-sheet-open',
  CITY_BANNER_IMAGE = 'city--banner-image',
  CITY_BENEFITS_SECTION = 'city--benefits-section',
  CITY_TESTIMONIAL_SECTION = 'city--testimonial-section',
  CITY_TESTIMONIAL_SECTION_CARD = 'city--testimonial-section-card',
  CITY_TESTIMONIAL_SECTION_MESSAGE = 'city--testimonial-section-message',
  CITY_BRAND_SECTION = 'city--brand-section',
  CITY_BRAND_SECTION_ICON = 'city--brand-section-icon',
  CITY_FACE_TO_FACE_SERVICE_SECTION = 'city--face-to-face-section',
  CITY_NOTIFY_ME_FORM = 'city--notify-me-form',
  CITY_NOTIFY_ME_FORM_INPUT_NAME = 'city--notify-me-form-input-name',
  CITY_NOTIFY_ME_FORM_INPUT_EMAIL = 'city--notify-me-form-input-email',
  CITY_NOTIFY_ME_FORM_BUTTON = 'city--notify-me-form-button',
  CITY_BRANCHES_NEAR_YOU_SECTION = 'city--branches-near-you-section',
  CITY_BRANCHES_NEAR_YOU_SECTION_INPUT = 'city--branches-near-you-section-input',
  CITY_HEALTH_CARE_SECTION = 'city--health-care-section',
  CITY_BRANCH_LIST_SECTION = 'city--branch-list-section',
  CITY_BRANCH_LIST_TITLE = 'city--branch-list-title',
  CITY_BRANCH_LIST_AVATAR = 'city--branch-list-avatar',
  CITY_BRANCH_LIST_ADDRESS = 'city--branch-list-address',
  CITY_BRANCH_LIST_WHATSAPP_BUTTON = 'city--branch-list-whatsapp-button',
  CITY_BRANCH_LIST_VIEW_BRANCH_BUTTON = 'city--branch-list-view-branch-button',
  CITY_BRANCH_LIST_SEE_ON_MAP_BUTTON = 'city--branch-list-see-on-map-button',
  CITY_BRANCH_LIST_TOGGLE_BUTTON = 'city--branch-list-toggle-butotn',
  CITY_BRANCH_LIST_AVATAR_DEFAULT = 'city--branch-list-avatar-default',
  CITY_BRANCH_LIST_ITEM = 'city--branch-list-item',
  CITY_BRANCH_PROFILE_SECTION = 'city--branch-profile-section',
  CITY_DOWNLOAD_APP_SECTION = 'city--download-app-section',
  CITY_DOWNLOAD_APP_SECTION_BUTTON = 'city--download-app-section-button',
  CITY_DOWNLOAD_APP_SECTION_QR_CODE = 'city--download-app-section-qr-code',
}
